// extracted by mini-css-extract-plugin
export var sliderRange = "_qs-2";
export var sliderRoot = "_qs-0";
export var sliderThumb = "_qs-3";
export var sliderTrack = "_qs-1";